var _path, _path2, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNpsZeroStateForeground = function SvgNpsZeroStateForeground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.9 78.47c.31.45.94.55 1.39.23l8.96-6.48c.45-.32.55-.95.24-1.4a36.94 36.94 0 1 1 60.96.1c-.31.45-.22 1.07.23 1.4l8.95 6.5A.98.98 0 0 0 91 78.6a50 50 0 0 0 9-28.54V100H0V50a50 50 0 0 0 8.9 28.47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 50V0h50A50 50 0 0 0 0 50m100-.07A50 50 0 0 0 50 0h50z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "#F7F7F7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    stroke: "#919191",
    strokeWidth: 2,
    dy: ".4em",
    textAnchor: "middle",
    textLength: 40
  }, "\n    NPS\n  ")));
};
export default SvgNpsZeroStateForeground;